
export const notificationStatusEnum = {
    NOT_SEEN: { value: 'NOT_SEEN' },
    SEEN: { value: 'SEEN' },
  };
  